export default () => ({
  schedules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/preview/resources/data.js